/* Exact keyword queries keep Shopify's result counts, facets and pagination authoritative. */
(function (root) {
  'use strict';
  const fallback = {
    fr: [{local: 'bottes', english: 'boots'}, {local: 'cuir', english: 'leather'}, {local: 'simili cuir', english: 'faux leather'}, {local: 'suédine', english: 'faux suede'}],
    de: [{local: 'stiefel', english: 'boots'}, {local: 'leder', english: 'leather'}, {local: 'kunstleder', english: 'faux leather'}, {local: 'kunstwildleder', english: 'faux suede'}, {local: 'lederoptik', english: 'faux leather'}, {local: 'wildlederoptik', english: 'faux suede'}],
    it: [{local: 'stivali', english: 'boots'}, {local: 'pelle', english: 'leather'}, {local: 'similpelle', english: 'faux leather'}, {local: 'camoscio sintetico', english: 'faux suede'}]
  };
  const language = () => (root.document?.documentElement?.lang || 'en').split('-')[0];
  const connectors = {
    fr: ['en', 'de', 'du', 'des', 'avec', 'et', 'à', 'au', 'aux', 'le', 'la', 'les'],
    de: ['aus', 'mit', 'und', 'in', 'im', 'der', 'die', 'das'],
    it: ['di', 'con', 'e', 'in', 'da', 'il', 'la', 'le', 'lo', 'gli']
  };
  let activeVocabulary = [];
  try { activeVocabulary = JSON.parse(root.document?.getElementById?.('zeya-search-vocabulary')?.textContent || '[]'); } catch (error) { /* Literal matching remains available. */ }
  const advanced = /(?:^|[\s(])(?:title|body|product_type|tag|vendor|variants\.(?:title|sku|barcode))\s*:|(?:^|\s)(?:AND|OR|NOT)(?:\s|$)|(?:^|\s)-\S|"(?:\\.|[^"\\])*"/;
  function query(value, locale = language()) {
    const text = String(value || '').trim();
    if (!text || advanced.test(text)) return text;
    const words = text.split(/\s+/);
    const lang = locale.split('-')[0];
    const vocabulary = [...(lang === language() ? activeVocabulary : []), ...(fallback[lang] || [])]
      .map(pair => ({...pair, words: pair.local.toLocaleLowerCase().split(/\s+/)}))
      .sort((a, b) => b.words.length - a.words.length);
    const groups = [];
    for (let index = 0; index < words.length;) {
      const pair = vocabulary.find(entry => entry.words.every((word, offset) => words[index + offset]?.toLocaleLowerCase() === word));
      const length = pair ? pair.words.length : 1;
      const original = words.slice(index, index + length).join(' ');
      const options = [JSON.stringify(original)];
      if (pair) {
        vocabulary.filter(entry => entry.words.join(' ') === pair.words.join(' ')).forEach(entry => {
          const alias = JSON.stringify(entry.english.toLocaleLowerCase());
          if (alias !== JSON.stringify(original.toLocaleLowerCase()) && !options.includes(alias)) options.push(alias);
        });
      }
      if (words.length === 1 && /\d/.test(original)) options.push('variants.sku:' + JSON.stringify(original), 'variants.barcode:' + JSON.stringify(original));
      groups.push({original, pair, value: '((' + options.join(' OR ') + '))'});
      index += length;
    }
    const omitConnectors = groups.length > 1 && groups.some(group => group.pair);
    return groups.filter(group => !omitConnectors || group.pair || !(connectors[lang] || []).includes(group.original.toLocaleLowerCase()))
      .map(group => group.value).join(' AND ');
  }
  const quoted = '"(?:\\\\.|[^"\\\\])*"';
  const groupPattern = '\\(\\(' + quoted + '(?: OR (?:(?:variants\\.sku|variants\\.barcode):)?' + quoted + ')*\\)\\)';
  const canonical = new RegExp('^' + groupPattern + '(?: AND ' + groupPattern + ')*$');
  function display(value) {
    const text = String(value || '');
    if (!canonical.test(text)) return text;
    const plain = [...text.matchAll(/\(\(("(?:\\.|[^"\\])*")/g)].map(match => JSON.parse(match[1])).join(' ');
    return query(plain) === text ? plain : text;
  }
  function url(value, terms) {
    const result = new URL(value.href || value, root.location?.origin);
    if (!/\/search\/?$/.test(result.pathname)) return result;
    const text = terms === undefined ? result.searchParams.get('q') : terms;
    if (text && text.trim()) {
      const locale = result.pathname.match(/\/([a-z]{2}(?:-[a-z]{2})?)\/search\/?$/i)?.[1] || language();
      result.searchParams.set('q', query(text, locale));
      result.searchParams.set('type', 'product');
      result.searchParams.set('options[prefix]', 'none');
    }
    return result;
  }
  const api = { query, display, url };
  root.ZeyaPreciseSearch = api;
  if (typeof module !== 'undefined') module.exports = api;
  if (!root.document) return;

  const current = new URL(root.location.href);
  const normalized = url(current);
  if (normalized.href !== current.href) root.location.replace(normalized.href);

  // Capture all native search forms, including the header and search-results page.
  root.document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof root.HTMLFormElement) || !form.hasAttribute('action')) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || !/\/search\/?$/.test(new URL(form.action, root.location.origin).pathname)) return;
    event.preventDefault();
    const target = new URL(form.action, root.location.origin);
    new root.FormData(form).forEach((value, key) => target.searchParams.append(key, value));
    root.location.assign(url(target, input.value).href);
  }, true);
})(typeof window === 'undefined' ? globalThis : window);
